import React, { useState, useEffect } from "react";
import { Grid, Typography, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import whatsappIcon from '../../../Recursos/wasap.png';
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase/firebase";

const BotonWhatsApp = () => {
    const [visible, setVisible] = useState(false);
    const [textos, setTextos] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        const unsub = onSnapshot(doc(db, "configuracion", "textos"), (snap) => {
            if (snap.exists()) setTextos(snap.data());
        });
        return () => unsub();
    }, []);

    // Abre automáticamente una sola vez después de 10s, cierra a los 10s
    useEffect(() => {
        const yaVista = sessionStorage.getItem("notificacion_vista");
        if (yaVista) return;

        const abrirTimeout = setTimeout(() => {
            setVisible(true);
            sessionStorage.setItem("notificacion_vista", "true");

            const cerrarTimeout = setTimeout(() => {
                setVisible(false);
            }, 10000);

            return () => clearTimeout(cerrarTimeout);
        }, 10000);

        return () => clearTimeout(abrirTimeout);
    }, []);

    // El botón "?" abre/cierra manualmente sin límite
    const toggleNotificacion = () => {
        setVisible((prev) => !prev);
    };

    return (
        <>
            {/* Notificación — encima del botón "?" */}
            <Grid sx={{
                position: 'fixed',
                bottom: '170px',
                right: '15px',
                zIndex: 1000,
                backgroundColor: '#fff',
                borderRadius: '12px',
                padding: '10px 14px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '8px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                maxWidth: '160px',
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(10px)',
                transition: 'opacity 0.4s ease, transform 0.4s ease',
                pointerEvents: visible ? 'auto' : 'none',
            }}>
                <Typography sx={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: '#000',
                    textAlign: 'center',
                    lineHeight: 1.3,
                    fontFamily: 'Poppins',
                }}>
                    {textos.whatsapp_promocion || "¡Reclama esta promoción!"}
                </Typography>

                <Button
                    component={Link}
                    to="/pagina-misteriosa"
                    onClick={() => setVisible(false)}
                    sx={{
                        backgroundColor: '#CC6F0F',
                        color: '#fff',
                        borderRadius: '10px',
                        fontSize: 12,
                        fontWeight: 700,
                        width: '100%',
                        fontFamily: 'Poppins',
                        textTransform: 'none',
                        '&:hover': { backgroundColor: '#a85a0c' },
                    }}
                >
                    Mirar
                </Button>
            </Grid>

            {/* Botón "?" — más pequeño que WhatsApp, abre/cierra la notificación */}
            <Grid
                onClick={toggleNotificacion}
                sx={{
                    position: 'fixed',
                    bottom: '120px',
                    right: '26px',
                    zIndex: 1000,
                    backgroundColor: '#FFA602',
                    borderRadius: '50%',
                    width: '45px',
                    height: '45px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                    cursor: 'pointer',
                    animation: 'pulse 1.8s infinite',
                    '@keyframes pulse': {
                        '0%':   { boxShadow: '0 0 0 0 rgba(255,166,2,0.6)' },
                        '70%':  { boxShadow: '0 0 0 10px rgba(255,166,2,0)' },
                        '100%': { boxShadow: '0 0 0 0 rgba(255,166,2,0)' },
                    },
                }}>
                <Typography sx={{ fontSize: 22, fontWeight: 700, color: '#fff', lineHeight: 1, fontFamily: 'Poppins' }}>
                    ?
                </Typography>
            </Grid>

            {/* Botón WhatsApp */}
            <Grid
                component="a"
                href="https://wa.me/+573137700223?text=Hola,%20quiero%20hacer%20un%20pedido."
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chatea con nosotros en WhatsApp"
                title="Chatea con nosotros en WhatsApp"
                sx={{
                    position: 'fixed',
                    bottom: '40px',
                    right: '15px',
                    zIndex: 1000,
                    backgroundColor: '#25D366',
                    borderRadius: '50%',
                    width: '70px',
                    height: '70px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                    transition: 'transform 0.3s ease',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    '&:hover': { transform: 'scale(1.08)' },
                }}>
                <img src={whatsappIcon} alt="Icono de WhatsApp" style={{ width: '35px', height: '35px' }} />
            </Grid>
        </>
    );
};

export default BotonWhatsApp;